import script from "./grid-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-base.vue?vue&type=script&setup=true&lang=ts"

import "./grid-base.vue?vue&type=style&index=0&id=2f8de456&lang=scss"

const __exports__ = script;

export default __exports__